import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RangeDateDirective } from './range-date.directive';
import { ClickOutisideDirective } from './click-outiside.directive';
import { GetGoogleAddressDirective } from './get-google-address.directive';
import { ChangeOrientationDirective } from './change-orientation.directive';
import { FitTextDirective } from './fit-text.directive';
import { NgVarDirective } from './ng-var.directive';



@NgModule({
  declarations: [
    RangeDateDirective,
    ClickOutisideDirective,
    GetGoogleAddressDirective,
    ChangeOrientationDirective,
    FitTextDirective,
    NgVarDirective,
  ],
    exports: [
        RangeDateDirective,
        ClickOutisideDirective,
        GetGoogleAddressDirective,
        ChangeOrientationDirective,
        FitTextDirective,
        NgVarDirective
    ],
  imports: [
    CommonModule
  ]
})
export class DirectivesModule { }
